import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrAnandNarnawareContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Anand Narnaware"
      specialization="Paediatrician & Your Baby's First Friend"
      experience="17 Years, with a special interest in newborn care"
      degrees="MBBS, DNB (Paediatrics), DCH from KEM Hospital Mumbai"
      quote="I believe I am becoming a pregnancy crafter who prepares parents before the baby arrives."
      sections={[
        {
          title: "My Philosophy on Paediatric Care",
          body: "My care begins in the third trimester. I believe in proactive paediatrics, which means preparing parents for the wonderful, and often overwhelming, first few months of a baby's life. We discuss everything from creating a safe sleep environment and understanding feeding cues to newborn care essentials and knowing when to call a doctor. My goal is to empower you with knowledge, so when your baby arrives, you feel prepared, confident, and ready to enjoy every moment.",
        },
        {
          title: "Why I Chose Myprega",
          body: "Myprega's model is revolutionary because it bridges the gap between gynaecological care and paediatric care. In a traditional system, parents meet the paediatrician only after the baby is born. Here, I get to be part of your journey from the beginning, building a foundation of trust and providing continuity of care that is simply unmatched.",
        },
        {
          title: "Beyond the Clinic",
          body: "As a father of two, I spend most of my free time building elaborate Lego creations and rediscovering the world through my children's eyes. I'm a huge advocate for early childhood reading and volunteer for a local literacy program.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "The Read-Aloud Handbook by Jim Trelease" },
        { icon: "🧱", label: "Favourite Hobby", value: "Building Lego with my kids\nVolunteering for child literacy programs" },
        { icon: "💬", label: "Parenting Mantra", value: "Children are not things to be molded, but people to be unfolded." },
      ]}
    />
  );
};

export default DrAnandNarnawareContent;
